import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { StepperVertical } from './StepperVertical';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import StoreIcon from '@material-ui/icons/Store';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import useWindowDimensions from '../views/Login'
import { formatChosenDate, capitalizarPalabras } from '../utils';

const useStyles = makeStyles((theme) => ({
  father: {
    width: '80vw',
    marginTop: '5vh',
    borderRadius: '10px',
    border:'1px solid #CCCCCC'
  },
  expandPro: {
    alignSelf: 'flex-end',
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expand: {
    
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expand2: {
    width:'125px',
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  preDivs: {
    display: 'flex',
    marginLeft: '20px',
    marginTop:'10px',
    alignItems: 'center',
    height: '3vh'
  },

  divGreen: {
    display: 'flex',
    backgroundColor: '#009A3F',
    color: '#ffffff',
    width: '100%',
    height: '10vh',
    alignItems: 'center'
  },
  divGreenMin: {
    display: 'flex',
    backgroundColor: '#009A3F',
    color: '#ffffff',
    width: '100%',
    height: '15vh',
    alignItems: 'center'
  },
  divsGreen: {
    width: '15vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  divsGreenMin: {
    width: '35vw',
    height: '5vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  divsGreenUlt: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  divsGreenMinUlt: {
    width:'45%',
    height: '5vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft:'1vw',
  },
  divGreenMargin: {
    borderRight: '1px solid #FFFFFF',
  },
  state: {
    height: '28px',
    backgroundColor: '#0069B4',
    borderRadius: '4px',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight:"0.35rem",
    paddingLeft:'0.35rem',
    marginRight:'1rem',
    marginLeft:'1rem'
  },
  lettersGreen: {
    marginTop: '5px',
    fontSize: '14px',
    paddingLeft:'3vw'
 
  },
  lettersGreenMin: {
    width: '55%',
    marginTop: '5px',
    fontSize: '12px'
  },
  lettersGreen2: {
    paddingLeft: '3vw',
    marginTop: '5px',
    fontSize: '16px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  lettersGreen2Min: {
    width: '55%',
    marginTop: '5px',
    fontSize: '12px',
    height: '80%',
  },
  iconColor: {
    color: 'rgba(0, 0, 0, 0.5)'
  },
  iconColorGreen: {
    color: '#009A3F',
    fontSize: 40,
  },
  iconColorGreenMin: {
    color: '#009A3F',
    fontSize: 25,
  },
  textOrder: {
    color: '#58595B',
    fontSize: '20px',
    fontWeight: 'bold'
  },
  textOrder2: {
    color: '#58595B',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  textGrayClear: {
    marginLeft: '5px',
    color: '#9D9D9C',
    fontSize: '16px',
  },
  textGrayClear2: {
    marginLeft: '5px',
    color: '#9D9D9C',
    fontSize: '14px',
  },
  textGray: {
    marginLeft: '5px',
    color: '#58595B',
    fontSize: '16px',
  },
  textGray2: {
    marginLeft: '5px',
    color: '#58595B',
    fontSize: '14px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  center: {
    display: 'flex', justifyContent: 'center'
  },
  rigth: {
    display: 'flex', justifyContent: 'flex-start'
  },
  clienteIcon:{
    display:'flex',
    alignItems:'center',
    width:'80%'
  },
  desCliente:{
    width: '90%'
  },
  descliente2:{
    marginLeft: '5px',
    color: '#58595B',
    fontSize: '14px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  }
}));


export const CardPedido = (data) => {
  const item = data.elem;
  const { width } = useWindowDimensions();
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  let estado = 'Programado';
  let color = '#9D9D9C';
 
  if (item.estado_orden.toUpperCase() === 'ENTREGA PARCIAL' || item.estado_orden.toUpperCase() === 'REPROGRAMADO' || item.estado_orden.toUpperCase() === 'RECHAZADO' || item.estado_orden.toUpperCase() === 'DEVOLUCIÓN TOTAL'|| item.estado_orden.toUpperCase() === 'CANCELADO' || item.estado_orden.toUpperCase() === 'ENTREGADO' || item.estado_orden.toUpperCase() === 'ENTREGA COMPLETA') {
    if(item.estado_orden.toUpperCase() === 'DEVOLUCIÓN TOTAL' || item.estado_orden.toUpperCase() === 'RECHAZADO'){
      estado = 'Rechazado'
      color = '#58595B';
    }else{
      estado = (item.estado_orden).charAt(0).toUpperCase() + ((item.estado_orden).slice(1)).toLowerCase();
    }
    
  }else if(item.estado_viaje.toUpperCase() !== "TERMINADO" && item.estado_orden.toUpperCase() !== "PROGRAMADO"  ){
    estado = 'En ejecución';
    color = '#0069B4';
  };
  // eslint-disable-next-line default-case
  switch (item.estado_orden.toUpperCase()) {
    case 'ENTREGA PARCIAL':
      color = '#C8D400';
      break;
    case 'REPROGRAMADO':
      color = '#FFCD1C';
      break;
    case 'CANCELADO':
      color = '#E4032E';
      break;
      case ('ENTREGADO' || 'ENTREGA COMPLETA'):
        color = '#009A3F';
      break;
  }

  const handleExpandClick = (e) => {
    e.preventDefault();
    setExpanded(!expanded);
  };
  return (
    <div className={classes.root}>
      <Card className={classes.father}>
        <CardContent>
          <div className={classes.preDivs}>
            <div className={[(width > 450) ? classes.textOrder : classes.textOrder2]}>{item.code}</div>
            <div className={classes.state} style={{ backgroundColor: color }}>{estado}</div>
          </div>
          <div className={classes.preDivs}>
            <StoreIcon className={classes.iconColor} />
            <div className={[(width > 450) ? classes.textGrayClear : classes.textGrayClear2]}>Cliente:</div>
            <div className={ classes.clienteIcon}>
            <div className={[(width > 450) ? classes.desCliente : classes.descliente2]}>{capitalizarPalabras(item.name)}</div>
              <IconButton
              className={clsx([ (width>1024)?classes.expandPro:(width > 750) ? classes.expand : classes.expand2], {
                [classes.expandOpen]: expanded,
              })}
              id="piedra"
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
              <ExpandMoreIcon className={[(width > 768) ? classes.iconColorGreen : classes.iconColorGreenMin]} />
            </IconButton>   
            </div>
           
          </div>
          <div className={classes.preDivs}>
            <LocationOnIcon className={classes.iconColor} />
            <div className={[(width > 450) ? classes.textGrayClear : classes.textGrayClear2]}>Destino:</div>
            <div className={[(width > 450) ? classes.textGray : classes.textGray2]}>{capitalizarPalabras(item.address)}</div>
          </div>
          <div className={classes.preDivs}>
            <LocalShippingIcon className={classes.iconColor} />
            <div className={[(width > 450) ? classes.textGrayClear : classes.textGrayClear2]}>Servicio:</div>
            <div className={[(width > 450) ? classes.textGray : classes.textGray2]}>{capitalizarPalabras(item.service_type)}</div>
          </div>
        </CardContent>

        <div className={[(width > 450) ? classes.divGreen : classes.divGreenMin]}>
          <CardActions >
            <div className={[(width > 450) ? classes.divsGreen + ' ' + classes.divGreenMargin : classes.divsGreenMin + ' ' + classes.divGreenMargin]}>
              <div className={[(width > 450) ? classes.lettersGreen : classes.lettersGreenMin]}>Fecha de carga</div>
              <div className={[(width > 450) ? classes.lettersGreen2 : classes.lettersGreen2Min]}>{formatChosenDate(item.appointment_time_carga, 0)}</div>
            </div>
            <div className={[(width > 450) ? classes.divsGreen + ' ' + classes.divGreenMargin : classes.divsGreenMin + ' ' + classes.divGreenMargin]}>
              <div className={[(width > 450) ? classes.lettersGreen : classes.lettersGreenMin]}>Vehículo</div>
              <div className={[(width > 450) ? classes.lettersGreen2 : classes.lettersGreen2Min]}>{item.license_plate}</div>
            </div>
            <div className={[(width > 450) ? classes.divsGreenUlt: classes.divsGreenMinUlt]}>
              <div className={[(width > 450) ? classes.lettersGreen : classes.lettersGreenMin]}>Conductor</div>
              <div className={[(width > 450) ? classes.lettersGreen2 : classes.lettersGreen2Min]}>{(item.conductor !== null)? capitalizarPalabras(item.conductor) : '-'}</div>
            </div> 
            
          </CardActions>
        </div>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <div  className={[(width > 780 ? classes.center : classes.rigth)]}>
            <StepperVertical item={item} />
            </div>
          </CardContent>
        </Collapse>
      </Card>
    </div>
  );
};

